export enum States {
    ON_L1 = 'ON_L1',
    CANDIDATE_FOR_L2 = 'CANDIDATE_FOR_L2',
    IN_TRANSIT_TO_L2 = 'IN_TRANSIT_TO_L2',
    ON_L2 = 'ON_L2',
    IN_TRANSIT_TO_L1 = 'IN_TRANSIT_TO_L1',
    READY_TO_REDEEM = 'READY_TO_REDEEM'
}
